/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
// tslint:disable:no-submodule-imports
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonExternalSharedModule, ExtConfirmationDialogComponent, ExtMessageDialogComponent, } from '@gh/common-external-shared';
import { CommonSharedModule } from '@gh/common-shared';
import { CommonSharedDataModule } from '@gh/common-shared-data';
import { KEYCLOAK_AUTH_MODE, KEYCLOAK_WITH_MOCK_AUTH_MODE, MOCK_AUTH_MODE, MOCK_BACKEND_DEV_MODULE } from '@gh/config';
import { CoreDataModule, CoreMockDataModule } from '@gh/core-data';
import { CoreMessagesModule } from '@gh/core-messages';
import { CoreTypeModule } from '@gh/core-type';
import { CoreUiCommonModule, CoreUiDialogsModule, CoreUiWaitingModule } from '@gh/core-ui';
import { SupplierSharedModule } from '@gh/supplier-shared';
import { SupplierSharedDataModule } from '@gh/supplier-shared-data';
import { AUTH_MODE } from '@gh/config';
import { SupplierAppComponent, SupplierCalendarComponent, SupplierInvoicesListComponent, SupplierOfficeInfoComponent, SupplierOfficeInfoDialogComponent, SupplierOrderInfoDialogComponent, SupplierPurchaseOrderListComponent, SupplierSharedDocsListComponent, } from './components';
import { SupplierAuthConfigModule, SupplierHttpClientConfigModule, SupplierMlsConfigModule } from './config';
import { SupplierBootstrapService } from './config/supplier-bootstrap.service';
import { SUPPLIER_MOCK_DATA } from './mock/supplier-mock-data';
import { SupplierCalendarBusinessService, SupplierInvoicesListBusinessService, SupplierOfficeActivator, SupplierPurchaseOrderListBusinessService, SupplierSharedDocsListBusinessService, } from './resources';
import { SupplierAppRoutingModule } from './supplier-app-routing.module';
import * as i0 from "@angular/core";
import * as i1 from "../core-data/core-data.module";
import * as i2 from "../core-type/core-type.module";
import * as i3 from "../core-ui/common/core-ui-common.module";
import * as i4 from "../core-ui/dialogs/core-ui-dialogs.module";
import * as i5 from "../core-ui/waiting/core-ui-waiting.module";
import * as i6 from "../common-shared-data/common-shared-data.module";
import * as i7 from "../common-shared/common-shared.module";
import * as i8 from "../common-external-shared/common-external-shared.module";
import * as i9 from "./config/supplier-auth-config.module";
import * as i10 from "../supplier-shared-data/supplier-shared-data.module";
import * as i11 from "../supplier-shared/supplier-shared.module";
var SupplierAppModule = /** @class */ (function () {
    function SupplierAppModule() {
    }
    SupplierAppModule.ɵmod = i0.ɵɵdefineNgModule({ type: SupplierAppModule, bootstrap: [SupplierAppComponent] });
    SupplierAppModule.ɵinj = i0.ɵɵdefineInjector({ factory: function SupplierAppModule_Factory(t) { return new (t || SupplierAppModule)(); }, providers: [
            SupplierBootstrapService, {
                provide: APP_INITIALIZER,
                useFactory: function (bootstap) { return function () { return bootstap.load(); }; },
                deps: [SupplierBootstrapService],
                multi: true,
            },
            SupplierOfficeActivator,
            SupplierPurchaseOrderListBusinessService,
            SupplierSharedDocsListBusinessService,
            SupplierCalendarBusinessService,
            SupplierInvoicesListBusinessService,
        ], imports: [[
                BrowserModule,
                BrowserAnimationsModule,
                // core modules
                CoreMessagesModule,
                CoreDataModule.forRoot(),
                CoreTypeModule.forRoot(),
                CoreUiCommonModule.forRoot(),
                CoreUiDialogsModule.forRoot({
                    standardSet: {
                        messageDialogType: ExtMessageDialogComponent,
                        confirmationDialogType: ExtConfirmationDialogComponent,
                    },
                }),
                CoreUiWaitingModule.forRoot(),
                // common modules
                CommonSharedDataModule.forRoot(),
                CommonSharedModule.forRoot(),
                CommonExternalSharedModule.forRoot(),
                // configuration modules
                (AUTH_MODE === KEYCLOAK_AUTH_MODE ? SupplierAuthConfigModule.useKeycloak() :
                    AUTH_MODE === KEYCLOAK_WITH_MOCK_AUTH_MODE ? SupplierAuthConfigModule.useKeycloakWithMock() :
                        AUTH_MODE === MOCK_AUTH_MODE ? SupplierAuthConfigModule.useMock() : SupplierAuthConfigModule.none()),
                SupplierHttpClientConfigModule,
                SupplierMlsConfigModule,
                // supplier modules
                SupplierSharedDataModule.forRoot(),
                SupplierSharedModule.forRoot(),
                SupplierAppRoutingModule,
                MOCK_BACKEND_DEV_MODULE ? CoreMockDataModule.withMockData(SUPPLIER_MOCK_DATA) : [],
            ]] });
    return SupplierAppModule;
}());
export { SupplierAppModule };
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(SupplierAppModule, { declarations: [SupplierPurchaseOrderListComponent,
        SupplierAppComponent,
        SupplierOfficeInfoComponent,
        SupplierOfficeInfoDialogComponent,
        SupplierSharedDocsListComponent,
        SupplierCalendarComponent,
        SupplierInvoicesListComponent,
        SupplierOrderInfoDialogComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        // core modules
        CoreMessagesModule, i1.CoreDataModule, i2.CoreTypeModule, i3.CoreUiCommonModule, i4.CoreUiDialogsModule, i5.CoreUiWaitingModule, i6.CommonSharedDataModule, i7.CommonSharedModule, i8.CommonExternalSharedModule, i9.SupplierAuthKeycloakModule, SupplierHttpClientConfigModule,
        SupplierMlsConfigModule, i10.SupplierSharedDataModule, i11.SupplierSharedModule, SupplierAppRoutingModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierAppModule, [{
        type: NgModule,
        args: [{
                imports: [
                    BrowserModule,
                    BrowserAnimationsModule,
                    // core modules
                    CoreMessagesModule,
                    CoreDataModule.forRoot(),
                    CoreTypeModule.forRoot(),
                    CoreUiCommonModule.forRoot(),
                    CoreUiDialogsModule.forRoot({
                        standardSet: {
                            messageDialogType: ExtMessageDialogComponent,
                            confirmationDialogType: ExtConfirmationDialogComponent,
                        },
                    }),
                    CoreUiWaitingModule.forRoot(),
                    // common modules
                    CommonSharedDataModule.forRoot(),
                    CommonSharedModule.forRoot(),
                    CommonExternalSharedModule.forRoot(),
                    // configuration modules
                    (AUTH_MODE === KEYCLOAK_AUTH_MODE ? SupplierAuthConfigModule.useKeycloak() :
                        AUTH_MODE === KEYCLOAK_WITH_MOCK_AUTH_MODE ? SupplierAuthConfigModule.useKeycloakWithMock() :
                            AUTH_MODE === MOCK_AUTH_MODE ? SupplierAuthConfigModule.useMock() : SupplierAuthConfigModule.none()),
                    SupplierHttpClientConfigModule,
                    SupplierMlsConfigModule,
                    // supplier modules
                    SupplierSharedDataModule.forRoot(),
                    SupplierSharedModule.forRoot(),
                    SupplierAppRoutingModule,
                    MOCK_BACKEND_DEV_MODULE ? CoreMockDataModule.withMockData(SUPPLIER_MOCK_DATA) : [],
                ],
                providers: [
                    SupplierBootstrapService, {
                        provide: APP_INITIALIZER,
                        useFactory: function (bootstap) { return function () { return bootstap.load(); }; },
                        deps: [SupplierBootstrapService],
                        multi: true,
                    },
                    SupplierOfficeActivator,
                    SupplierPurchaseOrderListBusinessService,
                    SupplierSharedDocsListBusinessService,
                    SupplierCalendarBusinessService,
                    SupplierInvoicesListBusinessService,
                ],
                declarations: [
                    SupplierPurchaseOrderListComponent,
                    SupplierAppComponent,
                    SupplierOfficeInfoComponent,
                    SupplierOfficeInfoDialogComponent,
                    SupplierSharedDocsListComponent,
                    SupplierCalendarComponent,
                    SupplierInvoicesListComponent,
                    SupplierOrderInfoDialogComponent,
                ],
                entryComponents: [
                    SupplierOfficeInfoDialogComponent,
                    SupplierOrderInfoDialogComponent,
                ],
                bootstrap: [SupplierAppComponent],
            }]
    }], null, null); })();
